import http from "../../services/http-client";
import { CASH_CENTER_TYPES } from "./constants";

const API_URL = process.env.REACT_APP_API_URL;
export const modifyCashCenterPayload = (
  cashCenter,
  currencies,
  countries,
  cashCenterId
) => {
  const getType = () => {
    const index = CASH_CENTER_TYPES.findIndex(
      (elm) => elm.id === cashCenter.type
    );
    if (index !== -1) {
      return CASH_CENTER_TYPES[index];
    }
    return {
      id: cashCenter.type,
      text: cashCenter.type,
    };
  };
  const getCurrency = (curr) => {
    const index = currencies.findIndex((elm) => elm.shortName === curr);
    if (index !== -1) {
      return currencies[index];
    }
    return {
      shortName: curr,
      name: curr,
    };
  };
  const getCountry = (curr) => {
    const index = countries.findIndex((elm) => elm.name === curr);
    if (index !== -1) {
      return countries[index];
    }
    return {
      code: curr,
      name: curr,
    };
  };

  const _cashCenter = {
    id: cashCenterId,
    name: cashCenter.name,
    type: getType(),
    primaryCurrency: getCurrency(cashCenter.primaryCurrency),
    barcode: cashCenter.barcode,
    locationId: cashCenter.locationId,
    status: { id: cashCenter.status, text: cashCenter.status },
    longitude: cashCenter.longitude || "0",
    latitude: cashCenter.latitude || "0",
    loadingBayArea: {
      id: cashCenter.loadingBayArea,
      text: cashCenter.loadingBayArea,
    },
    loadingBayCapacity: cashCenter.loadingBayCapacity,
    country: getCountry(cashCenter.country),
    state: { id: cashCenter.state, text: cashCenter.state },
    emirate: { id: cashCenter.emirate, text: cashCenter.emirate },
    city: { id: cashCenter.city, text: cashCenter.city },
    postalCode: cashCenter.postalCode,
    address: cashCenter.address,
    firstServiceDate: cashCenter.firstServiceDate
      ? new Date(cashCenter.firstServiceDate)
      : null,
    inactiveDate: cashCenter.inactiveDate
      ? new Date(cashCenter.inactiveDate)
      : null,
    serviceDays: cashCenter.serviceDays,
    offices: cashCenter.offices.map((office) => ({
      expanded: false,
      officeId: office.officeId,
      officeName: office.officeName,
      officeType: office.officeType,
      country: getCountry(office.country),
      state: { id: office.state, text: office.state },
      emirate: { id: office.emirate, text: office.emirate },
      city: { id: office.city, text: office.city },
      postalCode: office.postalCode,
      address: office.address,
      barcode: office.barcode,
      startDate: office.startDate ? new Date(office.startDate) : null,
      inactiveDate: office.inactiveDate ? new Date(office.inactiveDate) : null,
      status: { id: office.status, text: office.status },
      longitude: office.longitude,
      latitude: office.latitude,
      operationalWindows: office.operationalWindows.map((elm) => ({
        startDateTime: elm.startDateTime ? new Date(elm.startDateTime) : null,
        endDateTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
        cutOffTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
      })),
    })),
    operationalWindows: cashCenter.operationalWindows.map((elm) => ({
      startDateTime: elm.startDateTime ? new Date(elm.startDateTime) : null,
      endDateTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
      cutOffTime: elm.startDateTime ? new Date(elm.cutOffTime) : null,
    })),
    insuranceLimits: cashCenter.insuranceLimits.map((elm) => ({
      customerId: elm.customerId,
      currency: getCurrency(elm.currency),
      area: elm.area,
      limit: elm.limit,
    })),
    contactPersons: cashCenter.contactPersons,
    escalationGroups: cashCenter.escalationGroups.map((group) => {
      const item = {
        region: { id: group.region, text: group.region },
        routeNo: "",
        escalationLevel: group.escalationLevel,
        inAppRecipients: group.inAppRecipients.map((elm) => ({ item: elm })),
        emailRecipients: group.emailRecipients.map((elm) => ({ item: elm })),
        callRecipients: group.callRecipients.map((elm) => ({ item: elm })),
      };
      http
        .get(`${API_URL}/lookups/routes/region/${group.region}`)
        .then((res) => {
          item.routeNo =
            res.data.find((elm) => elm.routeNo === group.routeNo) || "";
        });
      return item;
    }),
    internalSLAs: cashCenter.internalSLAs.map((elm) => ({
      region: { id: elm.region, text: elm.region },
      serviceType: { id: elm.serviceType, text: elm.serviceType },
      activityType: { id: elm.activityType, text: elm.activityType },
      responseTime: elm.responseTime,
      attendedTime: elm.attendedTime,
      resolutionTime: elm.resolutionTime,
    })),
  };

  return _cashCenter;
};
